import { getPostalCodeIsUsableForGeoCodes } from 'cart-core';
import { useSelector } from 'react-redux';
import { useFindCurrentCountryRuleQuery } from '../api';
import { selectShippingPostalCode } from '../slices/shipping';
import useGeoCodesByShippingQuery from './useGeoCodesByShippingQuery';

/**
 * Returns whether the current shipping postal code should be regarded as valid in the client
 */
const useShippingPostalCodeIsValidOnClient = () => {
    const postalCode = useSelector(selectShippingPostalCode);
    const countryRulesQuery = useFindCurrentCountryRuleQuery();
    const geoCodesQuery = useGeoCodesByShippingQuery();

    const postalCodeIsValidOnClient = (
        !countryRulesQuery.data?.postalCodeRequired ||
        (
            countryRulesQuery.data?.geoCodeRequired &&
            getPostalCodeIsUsableForGeoCodes(postalCode) &&
            !geoCodesQuery.isError
        ) ||
        (
            !countryRulesQuery.data?.geoCodeRequired &&
            postalCode
        )
    );

    return postalCodeIsValidOnClient;
}

export default useShippingPostalCodeIsValidOnClient;
